import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  connect() {}
  cancel() {
    this.element.remove();
  }

  delayedCancel() {
    setTimeout(() => {
      this.cancel();
    }, 1000);
  }

  delayedCancel500() {
    setTimeout(() => {
      this.cancel();
    }, 500);
  }

  submitEnd(event) {
    console.log('submitEnd', event.detail.success);
    if (event.detail.success) {
      this.cancel();
    }
  }

  reload() {
    window.location.reload();
  }
}
